import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { deleteBuyerBlacklist } from "@/services/api/setting/blacklist";
import delay from "@/utils/delay";
import { useRequest } from "ahooks";
import { Modal, message } from "antd";

const useDeleteBlacklistRequest = () => {
    const { fetchOrders } = useOrderManagementStore();

    const { runAsync } = useRequest(deleteBuyerBlacklist, { manual: true });

    function handleDeleteBlacklist(order: OrderDTO) {
        const modal = Modal.confirm({
            title: "确定删除选择的黑名单嘛",
            content: <span className="error">删除后，需要几分钟更新订单的黑名单标签和锁单</span>,
            async onOk() {
                modal.update({ okButtonProps: { loading: true } });

                await runAsync(order.shopId, order.id);

                await delay(1500);

                message.success("删除成功");

                fetchOrders(order.shopId);
            },
        });
    }

    return handleDeleteBlacklist;
};

export default useDeleteBlacklistRequest;
